import { LoadingButton } from "@mui/lab";
import { Button, DialogActions } from "@mui/material";
import { useContext } from "react";
import useLocales from "src/hooks/useLocales";

import Context from "../context";

type Props = {
	isLoading?: boolean;
};

export default function FormFooter({ isLoading }: Props) {
	const { actions, state } = useContext(Context);
	const { translate } = useLocales();

	return (
		<DialogActions>
			<Button color='inherit' disabled={false} onClick={actions.onClose} variant='outlined'>
				{translate(state.secret === "" ? "app_secrets.cancel" : "app_secrets.accept")}
			</Button>
			{state.secret === "" && (
				<LoadingButton loading={isLoading} type='submit' variant='contained'>
					{translate("app_secrets.generate")}
				</LoadingButton>
			)}
		</DialogActions>
	);
}
